<button [id]="id" [type]="type"
    [ngClass]="{'bg-k-gray-disabled bg-none cursor-default' : isDisabled,'button-outline disabled' : outline,'icon-button':roundedIcon}"
    role="button" [disabled]="isDisabled" aria-pressed="false" (click)="clicked()" [style]="_style">
    <ng-content></ng-content>
</button>